type StringEnum<T extends string> = { [K in T]: K };

const proxy = new Proxy(
  {},
  {
    get(_, property): typeof property {
      return property;
    }
  }
);

export function stringEnum<T extends string>(): StringEnum<T> {
  return proxy as StringEnum<T>;
}
